import React from 'react';
import { Link } from 'react-router-dom';
import Services from "../../api/Services";

const ServiceSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className={"" + props.hclass}>
            <div className="container-fluid p-0">

                {/* TOP SECTION */}
                <div className="service-top">
                    <div className="image">
                        <img src={`https://res.cloudinary.com/dexvxngzg/image/upload/v1764738752/Lot_11_front_view_option_2_t41ont.jpg`} alt="QHB Services" />
                    </div>

                    <div className="content">
                        <h2 className="fade_bottom" style={{ fontWeight: "900" }}>
                            Quality Builds.
                        </h2>

                        <p className="fade_bottom">
                            At <strong>Quality Homes And Builders</strong>, we create modern and durable homes built with care and craftsmanship. We focus on quality, transparency, and a smooth building experience for every homeowner.
                        </p>

                    </div>
                </div>

                {/* SERVICES GRID */}
                <div className="service-wrap">
                    <div className="row">
                        {Services.slice(0, 4).map((service, item) => (
                            <div className="col-lg-3 col-md-6 col-12 fade_bottom" key={item}>
                                <div className="service-card">
                                    <div className="icon">
                                        <img src={service.Icon} alt={service.title} />
                                    </div>
                                    <h2>
                                        <Link onClick={ClickHandler} to={`/service-single/${service.slug}`} style={{ fontWeight: "900" }}>
                                            {service.title}
                                        </Link>
                                    </h2>
                                    <p>{service.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
}

export default ServiceSection;
